import React, { Component } from "react";
import { NavBar, Footer } from "../components/ReusableElements";
import Modal from "../components/Modal";
import axios from "axios";
import { withRouter, Link } from "react-router-dom";

class SubmitListings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      declarationChecked: false,
      termsChecked: false,
      show: false,
      title: "",
      description: "",
      pids: [],
      modalState: 1, // 1 - Close only, 2 - Cancel/Confirm

      brandName: "carousell", // call service to return user object with brand
      action: "HideListing",
      reason: "-", // todo add reason dropdown,
      submitStatus: false,

      buttonColour: "grey",
      disabled: true,

      companiesLoaded: false,
      brands: [],
      companyName: "",
      companyID: "",
    };
  }

  toggleModalContent() {
    switch (this.state.modalState) {
      case 1:
        return {
          title: "Wait a minute!",
          description: "No valid listings detected.",
        };
      case 2:
        return {
          title: "Are you sure?",
          description: `You are about to submit ${this.state.pids.length} listing(s) for takedown. \n This action is immediate and irreversible would you like to proceed with the submission?`,
        };

      case 3:
        return {
          title: "Oh no!",
          description:
            "Please make sure you've checked the declaration, terms and privacy policy boxes.",
        };

      case 4:
        return {
          title: "Oh no!",
          description: "You have reached your weekly takedown limit.",
        };

      case 5:
        return {
          title: "That's too much!",
          description: `You have exceeded your weekly limit by ${this.state.quota} listings.`,
        };

      default:
        return {
          title: "Something went wrong.",
          description: "Please drop us an email at crop@thecarousell.com",
        };
    }
  }

  toggleModal() {
    this.setState({ show: !this.state.show });
    var content = this.toggleModalContent();
    this.setState({
      title: content.title,
      description: content.description,
    });
  }

  handleTextOnChange(e) {
    var pids = [];
    var match;
    //regex extract urls
    var re =
      /(?:https:\/\/)(?:[a-z]{2}|w{3}|staging\.[a-z]{2})\.(carousell|carouselltech)\.(?:tw|sg|ph|hk|id|au|com|com\.my|com.hk|com.sg|com.tw|com.ph|co|co.id)\/p\/(?:.*?%\S{2}|%\S{2}-)*(?:.*?\w+-)*(\d+)(?:\/|)/g;

    while ((match = re.exec(e.target.value))) {
      pids.push(match[2]);
      pids = Array.from(new Set(pids));
    }

    if (pids.length > 0) {
      this.setState({
        pids: pids,
        modalState: 2,
      });
    } else {
      this.setState({
        pids: pids,
        modalState: 1,
      });
    }
  }

  toggleDeclarationChange = () => {
    this.setState({
      declarationChecked: !this.state.declarationChecked,
    });
  };

  toggleTermsChange = () => {
    this.setState({
      termsChecked: !this.state.termsChecked,
    });
  };

  handleOnSubmit() {
    let data = {
      ids: this.state.pids,
      action: this.state.action,
      reason: this.state.reason,
      company_id: this.state.companyID,
    };

    axios
      .post("/crop/submitids", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("carousellAuthToken"),
        },
      })
      .then((res) => {
        this.toggleModal();
        res.status === 200
          ? this.setState({ submitStatus: true })
          : this.setState({ submitStatus: false });

        this.props.history.push({
          pathname: "/confirmation",
          state: {
            success: this.state.submitStatus,
            redirectURI: "/submitlistings",
          },
        });
      });
  }

  checkQuota() {
    axios
      .post(
        "/crop/getquota",
        { company_id: this.state.companyID },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("carousellAuthToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.quota <= 0) {
          // reached quota
          this.setState(
            {
              modalState: 4,
            },
            () => this.toggleModal()
          );
        } else if (this.state.pids.length > res.data.quota) {
          // exceed quota
          this.setState(
            {
              modalState: 5,
              quota: this.state.pids.length - res.data.quota,
            },
            () => this.toggleModal()
          );
        } else {
          this.toggleModal();
        }
      })
      .catch((res) =>
        this.setState(
          {
            modalState: 0, // something went wrong
          },
          () => this.toggleModal()
        )
      );
  }

  SubmitForTakedown() {
    // check for quota
    this.checkQuota();
  }

  getBrands() {
    axios
      .post("/crop/getuserbrands", "{}", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("carousellAuthToken"),
        },
      })
      .then((response) => {
        return response.data.brands;
      })
      .then((data) => {
        if (data !== null) {
          let brands = data.map((brand) => {
            return { value: brand.id, display: brand.company_name };
          });
          let selected = brands.filter(
            (brand) => brand.value !== "2123123141r13f"
          );
          this.setState({
            brands: [{ value: "", display: "(Select your brand)" }].concat(
              selected
            ),
            companiesLoaded: true,
          });
        } else {
        }
      });
  }

  componentDidMount() {
    this.getBrands();
  }

  render() {
    const unChecked =
      (this.state.declarationChecked === false) |
      (this.state.termsChecked === false) |
      (this.state.pids.length === 0) |
      (this.state.companyID === "");
    return (
      <div className="Home">
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        <div className="submitlistings-input-box">
          <div className="submitlistings-box">
            <h1 style={{ color: "#D2232A" }}>Moderate Listings</h1>
            <p>
              Please exercise caution when submitting listings for takedown.
              Action will be taken against users who fail to comply with our
              guidelines.
            </p>

            <div className="brand-selector">
              {this.state.companiesLoaded === true ? (
                <div>
                  <select
                    value={this.state.companyID}
                    onChange={(e) =>
                      this.setState({ companyID: e.target.value })
                    }
                  >
                    {this.state.brands.map((brand) => (
                      <option key={brand.value} value={brand.value}>
                        {brand.display}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <div>No companies available.</div>
              )}
            </div>
          </div>

          <div className="submitlistings-submission-box">
            <textarea
              onChange={this.handleTextOnChange.bind(this)}
              className="submission-input"
              placeholder={`https://sg.carousell.com/p/nike-lunar-racer-12345678/\nhttps://sg.carousell.com/p/chanel-black-bag-1234322/`}
            />
          </div>
          <div className="submitlistings-checks">
            <div className="submitlistings-declaration">
              <input
                className="checkbox"
                type="checkbox"
                checked={this.state.declarationChecked}
                onChange={this.toggleDeclarationChange}
              />
              I believe in good faith that the listing(s) submitted for takedown
              is an infringing copy of my intellectual property or the
              intellectual property of the owner whom which I am authorised to
              act on behalf of.
            </div>

            <div className="submitlistings-terms">
              <input
                className="checkbox"
                type="checkbox"
                checked={this.state.termsChecked}
                onChange={this.toggleTermsChange}
              />
              I agree to the{" "}
              <Link
                to="/terms"
                target="_blank"
                style={{ textDecoration: "none", color: "blue" }}
              >
                CROP Members Terms & Conditions
              </Link>{" "}
              and consent to the use, collection and/or disclosure of my
              information in accordance with CROP’s{" "}
              <Link
                to="/privacy"
                target="_blank"
                style={{ textDecoration: "none", color: "blue" }}
              >
                Privacy Policy
              </Link>
              .
            </div>
          </div>
          <button
            className={
              unChecked
                ? "submitlistings-button"
                : "submitlistings-button-activated"
            }
            disabled={unChecked}
            type="button"
            onClick={this.SubmitForTakedown.bind(this)}
          >
            SUBMIT FOR TAKEDOWN
          </button>
        </div>

        <Modal
          show={this.state.show}
          modalState={this.state.modalState}
          toggleModalState={this.toggleModal.bind(this)}
          title={this.state.title}
          description={this.state.description}
          confirmFunction={this.handleOnSubmit.bind(this)}
        />
      </div>
    );
  }
}

export default withRouter(SubmitListings);



// WEBPACK FOOTER //
// ./src/containers/SubmitListings.js